<app-header></app-header>

<br />
<section id="faq" class="faq section-bg">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="section-title">
            <div class="col-12">
                <img class="img-fluid" src="assets/images/home/how-it-works.webp" alt="How it works" />
            </div>
        </div>
        <br />
    </div>
</section>

<app-footer></app-footer>
